// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"AddRoleForm_tableWrapper_2Qp91"};